<template>
  <div id="forgottenPassword" class="forgotten-password" :class="`forgotten-password--${showLogoNameOnItsOwn ? 'show-logo-name' : ''}`">
    <form v-if="!passwordResetEmailSent" class="form" @submit.prevent="resetPassword">
      <div class="form-row">
        <label for="email">Please enter your email address</label>
        <input type="email" id="email" v-model="email" autocomplete="email" required />
      </div>
      <button class="reset-btn" type="submit">Reset password</button>
      <p v-if="firebaseErrorMessage">{{ firebaseErrorMessage }}</p>
    </form>
    <p v-if="passwordResetEmailSent">We have send you an email, which will allow you to reset your password.</p>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  name: 'forgotten-password',
  title: 'Forgotten Password',
  props: {
    showLogoNameOnItsOwn: Boolean,
  },
  data: function() {
    return {
      email: '',
      firebaseErrorMessage: '',
      passwordResetEmailSent: false,
    };
  },
  methods: {
    resetPassword: function() {
      const actionCodeSettings = {
        url: `http://localhost:8080/register?email=${this.email}`,
      };
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(resp => {
          this.passwordResetEmailSent = true;
        })
        .catch(err => {
          this.firebaseErrorMessage = err.message;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.forgotten-password {
  padding-top: 2rem;

  &--show-logo-name {
    padding-top: 8rem;
  }
}

.logo {
  width: 21rem;
  margin: 0 auto 1rem auto;
}

.form {
  background-color: var(--text-color-alpha-10);
  border-radius: var(--border-radius);
  margin: 0 auto 7rem auto;
  max-width: 47rem;
  padding: 3rem;
}

.reset-btn {
  margin-top: 3rem;
  min-width: 16rem;
}

/* .forgotten-password,
.register {
  font-size: 1.4rem;
  max-width: none;
  text-align: center;
} */
</style>
